'use client';

import { AuthProvider } from 'ui/providers/auth-provider';

type UserLayoutProps = {
  children: React.ReactNode;
};

export default function UserLayout({ children }: UserLayoutProps) {
  return (
    <AuthProvider redirectToLogin>
      <>{children}</>
    </AuthProvider>
  );
}
